import BookingUnavailableImg from '../../img/booking_unavailable.svg';
import {useTranslation} from "react-i18next";
import {Link, useParams} from "react-router-dom";

const BookingUnavailableNotice = ({data}) => {
    const parseData = (data) => {
        if (data?.company) {
            return {
                name: data.company.name,
                city: data.company.city.name,
                phone: data.company.phone,
                address: data.company.address
            }
        } else if (data?.branch) {
            return {
                name: data.branch.name,
                city: data.branch.city.name,
                workSchedule: data.branch.workSchedule,
                phone: data.branch.phones[0].phone,
                address: data.branch.address
            }
        } else {
            return {}
        }
    }

    const resourceData = parseData(data);

    const {t : translate} = useTranslation();
    const {companyId} = useParams();

    return (
        <div className={"container mb-lg-5"}>
            <div className={"d-flex flex-column bg-white py-5 px-4 rounded-3 mb-4 mb-lg-5"}>
                <div className={"d-flex flex-column justify-content-center align-items-center col-xl-6 mb-lg-0 mb-3 mx-auto"}>
                    <div className="wrapper-error-img col-xl-6 d-flex justify-content-end mb-4">
                        <img src={BookingUnavailableImg} alt="Booking unavailable"/>
                    </div>
                    <h2 className={"main_text_color mb-2 fs-5 text-center"}>
                        {data?.branch ? translate('branchNameBookingDisabled') : translate('companyNameBookingDisabled')} {resourceData.name}, {resourceData.city} {translate('temporarilyUnavailable')}
                    </h2>
                    <p className={"mb-0 text-secondary text-center"}>
                        {translate('branchOnlineBookingDisabled')}
                    </p>
                </div>
            </div>
            <div className={"bg-white p-4 rounded-3 mb-4 mb-lg-5"}>
                <h2 className={"main_text_color mb-3 fs-5"}>
                    {resourceData.name}, {resourceData.city}
                </h2>
                <div className={"d-flex flex-column gap-3 fs-18"}>
                    <div className={"d-flex justify-content-between gap-5"}>
                        <p className={"text-secondary mb-0"}>{translate('aboutBranchPage.contact')}</p>
                        <p className={"mb-0 text-end"}>{resourceData.phone} <span className={"text-secondary"}>– {translate('aboutBranchPage.admin')}</span></p>
                    </div>
                    <div className={"d-flex justify-content-between gap-5"}>
                        <p className={"text-secondary mb-0"}>{translate('aboutBranchPage.address')}</p>
                        <p className={"mb-0 text-end"}>{resourceData.address}</p>
                    </div>
                    {resourceData.workSchedule ? (
                        <div className={"d-flex justify-content-between gap-5"}>
                            <p className={"text-secondary mb-0"}>{translate('aboutBranchPage.workSchedule')}</p>
                            <p className={"mb-0 text-end"}>{resourceData.workSchedule}</p>
                        </div>
                    ) : null}
                </div>
            </div>
            {data?.branch ? (
                <div className={"col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3 mx-auto"}>
                    <Link to={`/company/${companyId}`} className={"btn btn-primary w-100"}>{translate('aboutBranchPage.toBranchList')}</Link>
                </div>
            ) : null}
        </div>
    )
}

export default BookingUnavailableNotice;